<template>
  <div style="width:100%;padding-bottom: 84px;">
    <div style="width: 100%; height: 25px; background: #F6F6F6;" v-if="productList.length === 0"></div>
    <!-- <div class="shop-noproduct wrapper" v-if="productList.length === 0"></div> -->
    <div class="shop-noproduct wrapper" v-if="isNotList">
      <img src="../../assets/images/shopping.png" alt="">
      <div>您的购物车空空如也</div>
      <p>Your shopping cart is empty，Go and have a look at the products.</p>
      <!-- <div class="btn" @click="$router.push({ path: '/products', query: { name: '' } })">去逛逛</div> -->
    </div>
    <div class="shopping-trolley" v-else>
      <div class="shopping-product wrapper" v-if="productList.length > 0 && productListSow">
        <div class="shopping-top" v-if="productList.length > 0">
          <div class="wrapper">
            <div @click="asd" style="font-size:18px;font-weight: 400;color: #202020;">
              <div class="dian"></div>购物车
            </div>
            <div class="result"> <span>（全部产品{{ productList.length }}</span>
              <span style="margin:0 10px;">已上传顾客{{ result.uploadedUser }}</span>
              <span>共计本数{{ result.allBookNum }}）</span>
            </div>
            <p @click="clearCartDialog = true" v-if="productList.length > 0" style="float:right;">清空购物车</p>
          </div>
        </div>
        <el-divider></el-divider>
        <div class="sp-top">
          <p style="width:100px;">平台号</p>
          <p style="width:100px;">平台名称</p>
          <p style="width:160px;">商品信息</p>
          <p style="width: 400px;margin-right: 170px;">价格</p>
          <p>操作</p>
        </div>
        <div class="sp-content" v-for="(item, index) in productList" :key="index">
          <div class="sp_spudetail">
            <el-checkbox v-model="productList[index].checked" @change="changeCheck()" size="medium"></el-checkbox>
            <div style="margin-left: 20px;max-width: 100px;">{{ item.spus[0].storeCode }}</div>
            <div style="margin-left:55px;width: 150px;text-align: center;">{{ item.spus[0].storeCompanyName }}</div>
            <div class="sp_img"><img :src="item.skuGroupInfo ? item.skuGroupInfo.skuGroupImage + '?x-sds-process=image/resize,l_100,m_mfit' : ''" alt=""></div>
            <div class="sp_sputext" style="width: 150px;">
              <span class="sp_name" @click="$router.push({ path: item.skuGroupInfo.isSeries ? 'sysdetails' : '/details', query: { id: item.spuId } })"> {{ item.skuGroupInfo.length === 0 ? '产品已失效' :
                item.skuGroupInfo.spuProperty === 'NORMAL' ? item.skuGroupInfo.spuName : item.sample ? '【样品】' + item.skuGroupInfo.spuName : item.skuGroupInfo.spuName }}<br></span>
              <!-- <span style="margin:13px 0 11px;">{{ item.skuGroupInfo.skuGroupName }}<br></span> -->
              <span>{{ item.skuGroupInfo.dictSet }}</span>
            </div>
            <div class="sp_num">
              <span>已上传顾客：{{ item.result.uploadedUser + '/' + item.result.allUserNum }}<br></span>
              <span style="margin-right:5px">本数：{{ item.result.allBookNum }}</span>
            </div>
            <div class="sp_price"><span>￥{{ item.result.allUserPrice }}</span></div>
            <div class="sp_delete"><span @click="deleteItem = index, deleteSpuDialog = true" style="color:#C52222;">移除</span></div>
          </div>
          <component v-if="IsRefreshComponent" :ref="item.cartItemId" :is="'SampleUsers'" :skuGroupMsg='item' @changeSpuData="(data) => { return changeSpuData(data, index) }"
            @syncProData="(data, type) => syncProData(data, index, type)" :useType="'cart'" @removerSpu="removerItem(index)">
          </component>
        </div>
        <!-- <el-divider id="targetDiv" style="background:red;"></el-divider> -->
        <div class="fixedbtn" v-if="!showfixed">
          <div class="wrapper">
            <div style="display:flex;align-items: center;font-size:14px">
              <el-checkbox v-model="checkAll" @change="changeCheckAll()" size="medium">全选</el-checkbox>
              <span style="margin-left:20px;">全部产品（{{ productList.length }}）</span>
              <span style="margin:0 10px;">已上传顾客（{{ result.uploadedUser + '/' + result.allUserNum }}）</span>
              <span>共计本数（{{ result.allBookNum }}）</span>
            </div>
            <div class="result">
              <span class="submit_order" @click="remarkDailog('all')" style="background:#fff;color:#1061ee;border:1px solid #1061ee">修改全部地址</span>
              <span class="submit_order" @click="openSave()" style="margin-left:10px">提交订单</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 用于定位底部操作按钮 -->
      <div style="width:100%;height:1px;" ref="targetDiv"></div>
      <div class="fixed" v-if="showfixed">
        <div class="wrapper">
          <div style="display:flex;align-items: center;font-size:14px">
            <el-checkbox v-model="checkAll" @change="changeCheckAll()" size="medium">全选</el-checkbox>
            <span style="margin-left:20px;">全部产品（{{ productList.length }}）</span>
            <span style="margin:0 10px;">已上传顾客（{{ result.uploadedUser + '/' + result.allUserNum }}）</span>
            <span>共计本数（{{ result.allBookNum }}）</span>
          </div>
          <div class="result">
            <span class="submit_order" @click="remarkDailog('all')" style="background:#fff;color:#1061ee;border:1px solid #1061ee">修改全部地址</span>
            <span class="submit_order" @click="openSave()" style="margin-left:10px">提交订单</span>
          </div>
        </div>
      </div>
      <!-- 商品失效 -->
      <el-dialog title="移除确认" :visible.sync="deleteSpuDialog" :close-on-click-modal='false' :close-on-press-escape='false' :show-close='false' width="30%">
        <span>是否移除该产品？</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="deleteSpuDialog = false">取 消</el-button>
          <el-button type="primary" @click="deleteProduct(deleteItem)">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 商品失效 -->
      <el-dialog title="失效提示" :visible.sync="dialogVisible" :close-on-click-modal='false' :close-on-press-escape='false' :show-close='false' width="30%">
        <span>您的购物车部分商品失效</span>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="dialogVisible = false, deleteSpu()">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 清空购物车确认 -->
      <el-dialog :close-on-click-modal="false" title="重要提示" :visible.sync="clearCartDialog" width="30%">
        <span>确认清空购物车?</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="clearCartDialog = false" round>取 消</el-button>
          <el-button type="primary" @click="clearShopping()" round>确 定</el-button>
        </span>
      </el-dialog>
      <AddAddress ref="addressRef" @changeAddress="changeAddress"></AddAddress>
      <!-- 确认提交订单 -->
      <el-dialog :close-on-click-modal="false" title="申请样品" :visible.sync="dialogVisibleSample" width="30%">
        <div>
          <p>当前充值余额：￥{{ basicMsg.myBalance }}</p>
          <p>申请样品金额：￥{{ payPrice }}</p>
          <p>剩余金额：￥{{ basicMsg.balance }}</p>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisibleSample = false, loading = false">取 消</el-button>
          <el-button type="primary" @click="filterChecked()" :loading="loading">确 定</el-button>
        </span>
      </el-dialog>
    </div>
    <!-- <BatchUpdataAddress ref="BatchUpdataAddressRef" @filechange="filechange"></BatchUpdataAddress> -->
  </div>
</template>
<script>
import SampleUsers from './SampleUsers/index.vue'
import BatchUpdataAddress from './BatchUpdataAddress/index.vue'
import { uploadStr } from '@/utils/uploadWebImg'
import { getByStoreIds } from '@/api/epay'
import { cart, cartEmpty, cartItemRemove, orderSub, cartItemSpuChangeAddress, updateCartAddress, orderNow } from '@/api/oms'
import AddAddress from './AddAddressDialog/index.vue'
import { saveDimAddressFromExcel } from '@/api/crm'
import { decrypt } from '@/utils/reLogin'
export default {
  name: 'shopping-trolley',
  components: {
    SampleUsers,
    AddAddress
  },
  data () {
    return {
      payPrice: 0,
      basicMsg: {},
      dialogVisibleSample: false,
      loading: false,
      shoploading: null, // 修改全部地址
      IsRefreshComponent: true,
      checkSpusList: [], // 选择产品的spus(用于最下边批量修改地址)
      showfixed: false,
      productListSow: true,
      checkAll: false,
      deleteItem: undefined,
      deleteSpuDialog: false,
      jsonLock: false,
      disabledList: [],
      clearCartDialog: false,
      // awsSdk: null,
      name: [['1']],
      deleteDialog: false,
      dialogVisible: false,
      productList: [],
      isNotList: false,
      isSelected: false,
      selectList: [],
      queryInfo: {
        pageNum: 1,
        pageSize: 1000,
        total: 0
      },
      deleteSpuList: [],
      allAmount: 0,
      yes: 0,
      all: 0,
      standbyCreditLine: 0,
      result: {
        allUserNum: 0,
        uploadedUser: 0,
        allBookNum: 0
      },
      userType: localStorage.getItem('userType'),
      checkProd: 0,
      checkUserNum: 0,
      checkBookNum: 0,
      loginform: {}
    }
  },
  created () {
    console.log('重新加载')
    window.scrollTo(0, 50)
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  async mounted () {
    if (this.$route.query.mes) {
      console.log('this.$route.query.mes', this.$route.query.mes)
      this.loginform = decrypt(this.$route.query.mes)
      await this.logOutIn()
    } else {
      if (this.$checkAwsSdk('normal')) {
        this.$store.dispatch('awsSdk/getAwsSdk', 'normal')
      }
      this.getCart()
    }
  },
  methods: {
    // 数据太多时，提交订单固定在底部
    handleScroll () {
      const targetDivPosition = this.$refs.targetDiv.offsetTop
      // console.log('targetDivPosition', targetDivPosition - 800)
      const currentPosition = window.scrollY || document.documentElement.scrollTop
      // console.log('currentPosition', currentPosition)
      if (currentPosition >= targetDivPosition - 800) { // 减800是减去滚定条的高度
        // 滚动到了div的位置
        console.log('已经滚动到了div的位置')
        // 执行你需要的操作
        this.showfixed = true
      } else {
        this.showfixed = false
      }
    },
    // 购物车最底部批量修改地址
    // remarkDailog (index) {
    //   let list = this.productList
    //   this.checkSpusList = []
    //   list.forEach(a => {
    //     this.checkSpusList.concat(a.spus)
    //   })
    //   console.log('this.checkSpusList', this.checkSpusList)
    //   // this.$refs.BatchUpdataAddressRef.show(index)
    //   this.$refs.BatchUpdataAddressRef.show(index)
    // },
    remarkDailog () {
      let tableList = this.productList.filter(spu => {
        return spu.checked
      })
      if (tableList.length == 0) {
        this.$message.error('请选择要修改的地址')
        return
      }
      const firstStoreId = tableList[0].spus[0].sampleStoreId
      let IsTrue = tableList.every(item => item.spus[0].sampleStoreId === firstStoreId)
      if (!IsTrue) {
        this.$message.error('请选择相同平台号进行批量修改地址')
        return
      }
      this.$refs.addressRef.show('add', 0, 'all')
    },
    // addAddress (type, item, index) {
    //   this.$refs.addressRef.show(type, item, index)
    // },
    // 将选中的修改成相同地址
    async changeAddress (index, val) {
      console.log('index+++val', val)
      let tableList = this.productList.filter(spu => {
        return spu.checked
      })
      if (index === 'all') {
        this.shoploading = this.$loading({
          lock: true,
          text: '正在修改全部地址，请稍候',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        const promises = tableList.map(a => {
          console.log('aaaaaaqa', a)
          a.spus.forEach(async (item, index) => {
            item.addressId = val.id
            if (item.itemSpuId) {
              await cartItemSpuChangeAddress({
                addressId: val.id,
                itemSpuId: item.itemSpuId,
                params: { addressId: val.id }
              })
            }
          })
          return a
        })
        Promise.all(promises).then(posts => {
          console.log('posts', posts)
          this.IsRefreshComponent = false
          this.$nextTick(() => {
            // this.productList = posts
            this.IsRefreshComponent = true
            this.$notify({
              title: '成功',
              message: '全部地址修改成功',
              type: 'success'
            })
            this.shoploading.close()
            this.loadDataCart()
          })
        }).catch(function (reason) {
          console.log('出错了', reason)
        })
      } else {
        tableList.forEach(async (a) => {
          console.log('aaaaaaqa', a)
          // if (a.checked) {
          this.checkSpusList[index].address = val
          if (a.spus[index].itemSpuId) {
            await cartItemSpuChangeAddress({
              addressId: a.spus[index].address.id,
              itemSpuId: a.spus[index].itemSpuId,
              params: { addressId: a.spus[index].address.id }
            }).then(res => {
              console.log('修改地址成功')
              if (res.data.success) {
                this.$notify({
                  title: '成功',
                  message: '地址修改成功',
                  type: 'success'
                })
              }
            })
          }
          // }
        })
      }
      console.log('this.productList-1323435', this.productList)
    },
    // 上传的excel数据修改全部地址
    async filechange (value) {
      let tableList = this.productList.filter(spu => {
        return spu.checked
      })
      const firstStoreId = tableList[0].spus[0].sampleStoreId
      let IsTrue = tableList.every(item => item.spus[0].sampleStoreId === firstStoreId)
      if (!IsTrue) {
        this.$message.error('请选择相同平台号进行批量修改地址')
        return
      }
      for (let i in value) {
        let item = value[i]
        tableList = tableList.map(a => {
          a.spus = a.spus.map((res) => {
            console.log('找到一样的名称', res.memo, item.name)
            // 找到一样的名称并且该条信息注册过地址，直接将地址替换 && res.address?.completeAddress !== item.completeAddress
            if (res.memo == item.name) {
              console.log('找到一样的名称', res)
              return {
                ...res,
                oldAddress: res.address,
                address: item
              }
            } else {
              return res
            }
          })
          return a
        })
      }
      this.shoploading = this.$loading({
        lock: true,
        text: '正在修改全部地址，请稍候',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      var newList = []
      for (var i in tableList) {
        let res = tableList[i]
        const promises = res.spus.map(async data => {
          console.log('data', data)
          if (data.address?.id) {
            return data
          } else {
            let address = null
            // 批量修改的excel中匹配到相同名称的地址，获取地址Id
            if (data.address) {
              address = await saveDimAddressFromExcel(data.address)
            }
            // 匹配上地址，匹配上错误地址都将原有地址改为空
            if (data.itemSpuId) {
              let upAddress = await updateCartAddress({
                params: { cartSpuId: data.itemSpuId, addressId: address?.data?.data?.id || '' }
              })
              console.log('upAddress', upAddress)
            }
            data.addressId = address?.data?.data?.id || ''
            data.address = address?.data?.data || {}
            return data
          }
        })
        Promise.all(promises).then(posts => {
          res.spus = posts
          newList.push(res)
          if (newList.length == tableList.length) {
            console.log('newList', newList)
            this.IsRefreshComponent = false
            this.$nextTick(() => {
              this.productList = newList
              console.log('nextTick-this.productList', this.productList)
              this.IsRefreshComponent = true
              this.$notify({
                title: '成功',
                message: '全部地址修改成功',
                type: 'success'
              })
              this.shoploading.close()
            })
          }
        })
      }
    },
    // 选择
    changeCheck () {
      this.checkProd = 0
      this.checkUserNum = 0
      this.checkBookNum = 0
      let lock = true
      this.productList.forEach(spu => {
        // spu.checked = this.checkAll
        if (!spu.checked) {
          lock = false
        } else {
          console.log('spu.checked', spu)
          this.checkUserNum = this.checkUserNum + spu.result.allUserNum
          this.checkBookNum = this.checkBookNum + spu.result.allBookNum
          this.checkProd++
        }
      })
      this.checkAll = lock
      this.$forceUpdate()
    },
    changeCheckAll () {
      this.checkProd = 0
      this.checkUserNum = 0
      this.checkBookNum = 0
      this.productList.forEach(spu => {
        spu.checked = this.checkAll
        if (spu.checked) {
          this.checkUserNum = this.checkUserNum + spu.result.allUserNum
          this.checkBookNum = this.checkBookNum + spu.result.allBookNum
          this.checkProd++
        }
      })
    },
    checkShouldSave (list) {
      console.log('list', list)
      let lock = []
      list.forEach(spu => {
        let result = this.$refs[spu.cartItemId][0].checkSave()
        console.log('result', result)
        if (result) {
          lock.push(result)
        }
      })
      if (
        lock.some(item => item === 'user:address:null')
      ) {
        this.$notify({
          title: '失败',
          message: '地址不能为空，请绑定后重试',
          type: 'error'
        })
        return
      }
      if (lock.length !== 0) {
        this.$notify({
          title: '失败',
          message: '产品调整后未保存',
          type: 'error'
        })
        return
      }
      this.submitOrder(list)
    },
    // 提交订单
    filterChecked () {
      if (this.checkAll) {
        if (this.productList.some(item => {
          return item.spus.length === 0
        })) {
          this.$notify({
            title: '失败',
            message: '选择的商品没有客户',
            type: 'error'
          })
          return
        }
        this.checkShouldSave(this.productList)
      } else {
        console.log('this.productList', this.productList)
        let list = this.productList.filter(spu => {
          return spu.checked
        })
        console.log('list', list)
        if (list.length === 0) {
          this.$notify({
            title: '失败',
            message: '未选择商品',
            type: 'error'
          })
          return
        }

        if (list.some(item => {
          return item.spus.length === 0
        })) {
          this.$notify({
            title: '失败',
            message: '选择的商品没有客户',
            type: 'error'
          })
          return
        }
        this.loading = true
        this.checkShouldSave(list)
      }
    },
    // 同步数据
    syncProData (val, proIndex, type) {
      if (type === 'edit') {
        this.productList[proIndex].spus.forEach((user, userIndex) => {
          if (user.itemSpuId === val.itemSpuId) {
            this.productList[proIndex].spus[userIndex] = val
          }
        })
      } else if (type === 'add') {
        this.productList[proIndex].spus.push(val)
        console.log('this.productList[proIndex]', proIndex, this.productList[proIndex])
      } else if (type === 'deleteOnce') {
        this.productList[proIndex].spus.forEach((user, userIndex) => {
          if (user.itemSpuId === val) {
            this.productList[proIndex].spus.splice(userIndex, 1)
          }
        })
      } else if (type === 'deleteAll') {
        this.productList[proIndex].spus.length = 0
      } else if (type === 'editName') {
        this.productList[proIndex].spus.forEach((user, userIndex) => {
          if (user.itemSpuId === val.itemSpuId) {
            this.productList[proIndex].spus[userIndex].memo = val.name
          }
        })
      } else if (type === 'editNum') {
        this.productList[proIndex].spus.forEach((user, userIndex) => {
          if (user.itemSpuId === val.itemSpuId) {
            this.productList[proIndex].spus[userIndex].quantity = val.num
          }
        })
      } else if (type === 'editAddress') {
        this.productList[proIndex].spus.forEach((user, userIndex) => {
          if (user.itemSpuId === val.itemSpuId) {
            this.productList[proIndex].spus[userIndex].addressId = val.address.id
            this.productList[proIndex].spus[userIndex].addressDTO.completeAddress = val.address.completeAddress
          }
        })
      }
      console.log('this.productList', this.productList)
      this.changeCheck()
    },
    changeSpuData (data, index) {
      console.log('changeSpuData-index', index, data)
      this.productList[index].result = data
      this.countData()
      // bug 8372 添加
      this.changeCheck()
    },
    // 计算数据
    countData () {
      let allBookNum = 0
      let uploadedUser = 0
      let allUserNum = 0
      console.log('this.productList', this.productList)
      this.productList.forEach(spu => {
        allBookNum += spu.result ? spu.result.allBookNum : 0
        uploadedUser += spu.result ? spu.result.uploadedUser : 0
        allUserNum += spu.result ? spu.result.allUserNum : 0
      })
      this.result = {
        allBookNum, uploadedUser, allUserNum
      }
    },
    changeDisabled (val, index) {
      this.disabledList[index] = val
      this.$forceUpdate()
    },
    asd () {
    },
    // 已上传顾客信息
    // 移除购物车失效商品
    deleteSpu () {
      this.deleteSpuList.forEach((item, index) => {
        cartItemRemove({ channel: 'B2B', itemId: item.cartItemId }).then(res => {
          if (res.data.success) {
            if (index === this.deleteSpuList.length - 1) {
              this.$notify({
                title: '成功',
                message: '商品已删除',
                type: 'success'
              })
              this.getCart()
            }
          }
        })
      })
    },
    // 获取购物车
    async getCart () {
      await cart({ channel: 'B2B', params: { itemType: 'NORMAL', page: this.queryInfo.pageNum - 1, size: this.queryInfo.pageSize } }).then(res => {
        if (res.data.success) {
          let obj = res.data.data.content
          console.log('获取购物车', obj)
          this.deleteSpuList = res.data.data.content.filter((item) => {
            let lock = false
            if (item.skuGroupInfo === undefined || item.skuGroupInfo.skuGroupName === undefined) {
              lock = true
            }
            return lock
          })
          if (this.deleteSpuList.length !== 0) {
            this.dialogVisible = true
            return
          }
          obj.forEach(item => {
            item.spuType = item.prodType
            item.checked = false
            item.result = {
              uploadedUser: 0,
              allUserNum: 0,
              allBookNum: 0,
              allUserPrice: '0.00',
              allUserRealPrice: '0.00'
            }
          })
          this.productList = obj
          console.log('this.productList获取', this.productList)
          if (this.productList.length) this.isNotList = false
          else this.isNotList = true
        }
      })
    },
    deleteNum (index) {
      this.selectList[index].num--
      if (this.selectList[index].num <= 1) {
        this.selectList[index].num = 1
      }
    },
    addNum (index) {
      this.selectList[index].num++
    },
    changeCheckbox (val, index) {
      val = !val
      this.selectList[index].status = val
    },
    deleteData (index) {
      this.$refs.combinedDialogRef.show('delete', '重要提示', '是否确定删除该产品？', this.selectList, index)
    },
    deletaAll () {
      const checkedlist = []
      for (var i in this.selectList) {
        if (this.selectList[i].status === true) {
          checkedlist.push(i)
        }
      }
      this.$refs.combinedDialogRef.show('delete', '重要提示', '是否确定删除该产品？', this.selectList, checkedlist)
    },
    checkedAll (e) {
      if (e.target.checked) {
        for (var i in this.selectList) {
          this.selectList[i].status = true
        }
      } else {
        for (var j in this.selectList) {
          this.selectList[j].status = false
        }
      }
    },
    // remarkDailog (title, content, index) {
    //   this.$refs.combinedDialogRef.show('remark', title, content, '', index)
    // },

    // changeRemark (val) {
    //   this.selectList[val.index].remark = val.message
    // },
    //  上传
    upload () {
      this.$refs.myVueDropzone.saveImg()
    },
    // 删除产品最后一个的时候直接移除
    removerItem (index) {
      console.log('移除', this.productList)
      this.deleteProduct(index)
    },
    //  移除购物车的产品
    async deleteProduct (index) {
      this.productListSow = false
      cartItemRemove({ channel: 'B2B', itemId: this.productList[index].cartItemId }).then(async res => {
        if (res.data.success) {
          this.$notify({
            title: '成功',
            message: '商品已移除',
            type: 'success'
          })
          this.productListSow = true
          this.loadDataCart()
        }
      })
    },
    // 重新加再购物车数据
    async loadDataCart () {
      this.IsRefreshComponent = false
      await this.getCart()
      this.$nextTick(() => {
        this.IsRefreshComponent = true
      })
      console.log('this.productList1', this.productList)
      this.countData()
      this.deleteSpuDialog = false
      this.changeCheck()
      console.log('this.productList2', this.productList)
      if (this.productList.length === 0) {
        this.isNotList = true
      }
    },
    //  清空购物车
    clearShopping () {
      let spus = []
      this.productList.forEach(item => {
        spus.push(...item.spus)
      })
      cartEmpty({ itemType: 'NORMAL' }).then(res => {
        if (res.data.success) {
          this.countData()
          this.getCart()
          this.$notify({
            title: '成功',
            message: '已清空购物车',
            type: 'success'
          })
          this.clearCartDialog = false
        }
      })
    },
    submitOrder (list) {
      console.log('listlistlist', list)
      // 可以使用授信额度
      let money = this.standbyCreditLine + this.basicMsg.balance
      if (money < 0) {
        this.$message.error('平台余额不足')
        return
      }
      let arr = []
      let addressLock = false
      list.forEach(sku => {
        let obj = {
          addressId: sku.spus[0].addressId,
          agentId: null,
          cartItemId: sku.cartItemId,
          channel: 'B2B',
          originType: sku.originType,
          // spus: [],
          sskus: [],
          storeId: sku.spus[0].sampleStoreId
        }
        sku.spus.forEach(user => {
          // obj.sskus.push(user.itemSpuId)
          if (user.addressId === undefined) {
            console.log('user', user)
            addressLock = true
          }
          console.log('user.skus+', user.skus)
          user.skus.forEach(item => {
            let obj2 = {
              qrCodeFlagHave: item.qrCodeFlagHave,
              folderName: user.folderName || '',
              memo: user.memo || '',
              cartSkuId: item.cartSkuId,
              skuId: item.skuId,
              weight: item.weight || '',
              spuId: user.itemSpuId,
              url: '',
              samplePrice: user.samplePrice,
              sampleRealPrice: sku.result.allUserRealPrice, // 实际支付价格
              sampleOnlinePriceTotal: user.sampleOnlinePriceTotal,
              obj33: ''
            }
            if (item.images) {
              obj2.url = item.images[0].url
            }
            obj.sskus.push(obj2)
          })
        })
        if (obj.sskus.length !== 0) {
          arr.push(obj)
        }
      })
      if (arr.length === 0) {
        this.$notify({
          title: '失败',
          message: '请上传图片并保存后提交',
          type: 'error'
        })
        return
      }
      let allNum = 0
      arr.forEach(order => {
        order.sskus.forEach(pro => {
          allNum++
        })
      })
      let finishNum = 0
      arr.forEach(order => {
        order.sskus.forEach(async pro => {
          console.log('pro.obj33', pro)
          if (pro.obj33 !== '') {
            let awsAdk = this.$store.state.awsSdk.normal.s3
            // 存到永久桶里
            if (pro?.qrCodeFlagHave) {
              if (this.$checkAwsSdk('special')) {
                await this.$store.dispatch('awsSdk/getAwsSdk', 'special')
              }
              awsAdk = this.$store.state.awsSdk.special.s3
            } else {
              if (this.$checkAwsSdk('normal')) {
                await this.$store.dispatch('awsSdk/getAwsSdk', 'normal')
              }
              awsAdk = this.$store.state.awsSdk.normal.s3
            }
            uploadStr(JSON.stringify(pro.obj33), awsAdk).then(res => {
              if (res === 'error') {
                this.$notify({
                  title: '失败',
                  message: '服务器问题，请刷新页面重试或联系管理员',
                  type: 'error'
                })
                return
              }
              finishNum++
              pro.url = res
              delete pro.obj33
              if (allNum === finishNum) {
                this.order(arr)
              }
            })
          } else {
            finishNum++
            delete pro.obj33
            if (allNum === finishNum) {
              this.order(arr)
            }
          }
        })
      })
    },
    async order (arr) {
      console.log('提交订单数据', arr)
      await orderSub(arr).then(res => {
        if (res.data.success) {
          this.$notify({
            title: '成功',
            message: '已提交订单',
            type: 'success'
          })
        }
        this.loading = false
        this.$router.push({ path: '/order' })
      })
    },
    openSave () {
      let list = this.productList.filter(spu => {
        return spu.checked
      })
      console.log('openSaveList', list)
      if (list.length === 0) {
        this.$message.warning('请选择商品')
        return
      }
      const firstStoreId = list[0].spus[0].sampleStoreId
      const firstAddress = list[0].spus[0].addressDTO.completeAddress
      let IsTrue = list.every(item => item.spus[0].sampleStoreId === firstStoreId && item.spus[0].addressDTO.completeAddress === firstAddress)
      console.log('storeIdIsTrue', IsTrue)
      if (!IsTrue) {
        this.$message.error('请选择相同平台号相同收货信息的样品提交订单')
        return
      }
      this.payPrice = 0
      list.forEach(e => {
        // 实际支付的价格
        this.payPrice += parseFloat(((e.spus[0].sampleRealPrice / e.spus[0].quantity) * e.spus[0].quantity).toFixed(2))
      })
      getByStoreIds(firstStoreId).then(res => {
        if (res.data.success) {
          this.standbyCreditLine = res.data.data.standbyCreditLine
          this.basicMsg.myBalance = res.data.data.balances.ACCT.balance
          this.basicMsg.balance = parseFloat((this.basicMsg.myBalance - this.payPrice).toFixed(2))
          this.dialogVisibleSample = true
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
@import 'styles';

@deep: ~'>>>';

.wrapper {
  width: 1300px;
}

@{deep} .el-collapse-item__header {
  flex-flow: row-reverse;
  padding-right: 5px;
}

@{deep} .el-collapse {
  border-top: none;

  .el-collapse-item__header {
    border-bottom: 1px solid #b2b2b2;
  }

  .sp-upload {
    border-top: none !important;
  }
}

/deep/.el-table {
  background: #EFEFEF;
}

/deep/.el-table__row {
  .success {
    background: #EFEFEF !important;

    .color-blue {
      font-size: 16px;
      font-family: Source Han Sans CN, Source Han Sans CN-Regular;
      font-weight: 400;
      color: #ff4400 !important;
    }
  }

  .color-blue {
    font-size: 16px !important;
    font-family: Source Han Sans CN, Source Han Sans CN-Regular;
    font-weight: 400 !important;
    color: #ff4400 !important;
  }
}

/deep/.shopping-select {
  .el-table__header {
    width: 1200px !important;
  }
}

/deep/.el-table__header-wrapper {
  background: #DBDBDB !important;
  border-radius: 50px;

  // .el-table__header {
  //   margin: auto;
  // }

  th {
    background: #DBDBDB;
  }

  @{deep}.el-table {

    @{deep}.el-table__cell {
      background: #DBDBDB !important;

    }

    tr {
      background: #DBDBDB !important;

    }
  }
}

/deep/.cell {
  font-size: 14px !important;
  font-family: Source Han Sans CN, Source Han Sans CN-Regular;
  font-weight: 400;
  color: #242424 !important;
  padding-left: 10px;
  padding-top: 2px !important;
}

/deep/.el-table__expanded-cell {
  .success {
    background: #EFEFEF !important;
  }

  .drag_title,
  .drag_content {
    background: #EFEFEF !important;
  }
}

/deep/.reminder {
  width: 1221px;
}

/deep/.function p {
  padding: 0 10px !important;
}

/deep/ .tipStyple {
  background: #EFEFEF !important;
}

/deep/.el-input-number--mini {
  width: 101px;
  height: 22px;
  border-radius: 5px;
}

/deep/.el-input--mini .el-input__inner {
  height: 23px !important;
  line-height: 23px !important;
}

/deep/.el-input-number__decrease,
/deep/.el-input-number__increase {
  width: 28px !important;
  height: 22px !important;
  line-height: 22px !important;
  background: #dfdfdf !important;
  color: #444444 !important;
  font-size: 18px !important;
}

@{deep}.el-dialog__header {
  padding: 20px 20px 10px !important;
}

/deep/.el-table__row {
  .cell {
    font-size: 14px;
    font-family: Source Han Sans CN, Source Han Sans CN-Normal;
    font-weight: normal;
    text-align: left;
    color: #666666;

    .table_span {
      font-size: 14px;
      font-family: Source Han Sans CN, Source Han Sans CN-Normal;
      font-weight: normal;
      text-align: left;
      color: #666666;
    }

    .table_btn:first-of-type {
      margin: 0 !important;
      padding: 0 !important;
    }
  }

}

/deep/.el-table th.el-table__cell>.cell {
  text-align: left;
}

/deep/ .el-divider--horizontal {
  margin: 13px 0 21px 0 !important;
}

/deep/.el-table__header {
  // width: 1220px !important;
}

/deep/.Single-btn {
  margin-top: 30px !important;
}
</style>
